export var apiEndpoints = [
	{
		id : 'search',
		endpoint : 'search',
	}
];